// export const API_URL ="http://localhost:3011";
// export const IMG_URl = "http://localhost:3011/images/1.jpg";
// export const IMG_URl1 = "http://localhost:3011/images/1.jpg";
// export const IMG_URl2 = "http://localhost:3011/images/2.jpg";
// export const IMG_URl3 = "http://localhost:3011/images/3.jpg";

export const UPLOADS_API_URL = 'https://srv547457.hstgr.cloud:3020';
export const API_URL = 'https://srv547457.hstgr.cloud:3009';